import type { FilesProxySchema } from '@iconik-io/iconik-api/src/services/files';

import { getStreamFormat } from './get_stream_format';
import {
  allowedAudioProxyFormatsSet,
  allowedImageProxyFormatsSet,
  allowedStreamProxyFormatsSet,
  allowedVideoProxyFormatsSet,
  MEDIA_TYPE_AUDIO,
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_STREAM,
  MEDIA_TYPE_VIDEO,
  type MediaType,
} from './media_type';

const knownVideoCodecs = new Set<string | undefined>(['h264']);

export function getProxyMediaType(
  proxyFile: FilesProxySchema | undefined,
): MediaType | undefined {
  const streamFormat = getStreamFormat(proxyFile?.url ?? '') !== undefined;

  if (streamFormat) {
    return MEDIA_TYPE_STREAM;
  }
  if (knownVideoCodecs.has(proxyFile?.codec)) {
    return MEDIA_TYPE_VIDEO;
  }
  if (!proxyFile?.format) {
    return undefined;
  }
  const format = proxyFile.format.toUpperCase();

  if (allowedImageProxyFormatsSet.has(format)) {
    return MEDIA_TYPE_IMAGE;
  }
  if (allowedVideoProxyFormatsSet.has(format)) {
    return MEDIA_TYPE_VIDEO;
  }
  if (allowedAudioProxyFormatsSet.has(format)) {
    return MEDIA_TYPE_AUDIO;
  }
  if (allowedStreamProxyFormatsSet.has(format)) {
    return MEDIA_TYPE_STREAM;
  }

  return undefined;
}
